// extracted by mini-css-extract-plugin
export default {"component":"bj0pyk","button":"cj0pyk","text":"dj0pyk","icon":"ej0pyk","logo":"fj0pyk"};